import React from 'react'
import Navbar from '../Components/Navbar'
import img from '../Assets/blog.png'
import { Helmet } from "react-helmet";

function BlogDetail() {
  return (
     <>
     <Helmet>
  <title>Preventive Care & Fertility Health | IVF Expert Advice Delhi</title>

  <meta
    name="description"
    content="Understand the importance of preventive care in fertility and women’s health. Expert advice by Dr. Monika Gupta, IVF specialist in Delhi with 15+ years experience."
  />

  <meta
    name="keywords"
    content="preventive care fertility, women health tips, IVF advice Delhi, fertility health care, infertility prevention, gynecology care Delhi"
  />


  <meta property="og:title" content="Preventive Care & Fertility Health | IVF Expert Delhi" />
  <meta property="og:description" content="Learn how preventive care improves fertility and overall health." />
  <meta property="og:type" content="article" />
</Helmet>
    <Navbar/>
      <div className='banner-page'>
        <h3>Blog Detail</h3>

        <p>Home-Blog Detail</p>

        </div>

 <div className="blog-container">
      <div className="blog-wrapper">

        {/* LEFT CONTENT */}
        <div className="blog-left">

          <h1 className="blog-main-title">
            Understanding the importance of preventive care
          </h1>

          <p className="blog-subtitle">
            Preventive care plays a crucial role in maintaining overall health
            and catching potential health issues early, before they become serious.
          </p>

          <div className="blog-hero-image">
            <img src={img} alt="blog" />
          </div>

          <div className="blog-meta">
            <span>📅 14 June 2023</span>
            <span>💬 Comment (06)</span>
            <div className="blog-share">
              <span>Share:</span>
              <i className="fab fa-facebook-f"></i>
              <i className="fab fa-instagram"></i>
              <i className="fab fa-twitter"></i>
            </div>
          </div>

          <h2 className="blog-second-title">
            The most common business debate isn't as black and white as you might think
          </h2>

          <p className="blog-text">
            He moonlights difficult-engrossed, sportsmen. Interested has all
            Devonshire difficulty gay assistance joy. Unaffected of compliment
            alteration to. Place voice no arises along to.
          </p>

          <ul className="blog-list">
            <li>The standard chunk of Lorem Ipsum used since the 1500s.</li>
            <li>Reproduced below for those interested.</li>
            <li>It is a long-established fact that a reader will.</li>
            <li>Distracted by the readable content of a page.</li>
          </ul>

          <div className="blog-gallery">
            <img src={img} alt="gallery" />
            <img src={img} alt="gallery" />
          </div>

          <h3 className="blog-third-title">
            Ten questions you should answer truthfully
          </h3>

        </div>

        {/* RIGHT SIDEBAR */}
        <div className="blog-right">
          <h3 className="sidebar-title">Recent Articles</h3>

          {[1,2,3,4,5].map((item,index)=>(
            <div key={index} className="recent-item">
              <img src={img} alt="recent"/>
              <div>
                <span className="recent-date">📅 14 June 2023</span>
                <p>Interdum velit laoreet id donec ultrices tincidunt arcu.</p>
              </div>
            </div>
          ))}

        </div>

      </div>
    </div>


</>
  )
}

export default BlogDetail
